import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { IntegrationTokenResource } from "@exonn/js-sdk";

export const module: Module = {
  id: ResourceEnum.IntegrationToken,
  bigIcon: <i className="icon-20-label_conf" />,
  smallIcon: <i className="icon-15-label_conf" />,
  name: (t: TFunction) => t("moduleName.integration-token"),

  tabs: {
    edit: {
      getTitle: (resource: IntegrationTokenResource) => resource.name,
    },
  },
};
